import { render, staticRenderFns } from "./ConfigurationGroup.vue?vue&type=template&id=604fcfcf"
import script from "./ConfigurationGroup.vue?vue&type=script&lang=js"
export * from "./ConfigurationGroup.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports